import React, { useEffect } from 'react';

const LoadingComponent = ({ isLoading }) => {
  useEffect(() => {
    if (isLoading) {
      document.documentElement.style.overflow = 'hidden'; // HTML 스크롤 차단
    } else {
      document.documentElement.style.overflow = ''; // HTML 스크롤 복원
    }

    return () => {
      document.documentElement.style.overflow = ''; // 컴포넌트 언마운트 시 복원
    };
  }, [isLoading]);

  return (
    <section className={`alert_pop ${isLoading === true ? 'dsp-b' : ''}`}>
      <div className="container align-c bg-none">
        <div>
          <img src="/assets/images/loading_ani.png" className="loading" />
        </div>
        <div className="fs-20 font-white mt-20">인증이 진행 중입니다.</div>
      </div>
      <div className="black_stage"></div>
    </section>
  );
};

export default LoadingComponent;
